var MpPageDocuments;

(function() {
    if (!document.querySelector('#vue-body-documents')) {
        return;
    }

    // Legacy funcionality management in a single class because same idBody
    // fom DocumentsController. Here we manage it through mixins.
    var sectionList = {
        documents: MpPublicDocuments,
        documents_search: MpSearchDocuments,
        documents_tags: MpTagDocuments
    };

    if (GLOBAL_SECTION === 'documents_search') {
        Vue.component('flat-pickr', VueFlatpickr);
    }

    MpPageDocuments = new Vue({
        el: '#vue-body-documents',
        mixins: [MpPaginator, MpVideoModal, sectionList[GLOBAL_SECTION]],
        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            IMAGE_PATH: '/resources/documents/',

            itemList: [],

            overlay: null,

            isInitialized: false,
        },
        computed: {
        },
        methods: {

            getCommentsUri: function(uri) {
                return uri + '#comments';
            },

            addDomItem: function(item) {
                this.itemList.push({
                    id: item.getAttribute('data-id'),
                    comments: !item.querySelector('.js-item-comments').classList.contains('comments--blocked'),
                    counterComments: item.querySelector('.js-item-comments').getAttribute('data-counter'),
                    origin_image: item.querySelector('.js-item-image').getAttribute('src'),
                    date: item.querySelector('.js-item-date').innerHTML.trim(),
                    uri: item.querySelector('.js-item-uri').getAttribute('href'),
                    origin_name: item.querySelector('.js-item-origin').innerHTML.trim(),
                    title: item.querySelector('.js-item-title').innerHTML.trim(),
                    intro: item.querySelector('.js-item-intro').innerHTML.trim(),
                });
            },

            onItemsLoaded: function(response) {
                if (response.data.result == this.RESPONSE_OK) {
                    this.itemList = response.data.documents;
                    this.updatePaginator(response);
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                window.addEventListener('hashchange', this.onHashChange);
                this.onHashChange();

                this.initPaginator();
                this.isInitialized = true;
            },
        },
        filters: {},

        mounted: function() {
            this.setInitialPage(parseInt(this.$refs.ssrPaginator.dataset.page));
            this.$refs.ssrPaginator.querySelectorAll('.js-page-item').forEach(this.addDomPage);

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
            window.removeEventListener('hashchange', this.onHashChange);
        }
    });

})();
